(function () {
	// --- State & DOM Setup ---
	let currentStep = 0;
	const steps = document.querySelectorAll(".funnel-step-content");
	const sidebarSteps = document.querySelectorAll(".funnel-step");
	const nextBtn = document.getElementById("funnel-next-btn");
	const prevBtn = document.getElementById("funnel-prev-btn");
	const titleEl = document.getElementById("funnel-title");
	const translations = FoxTheme.custom_made_funnel;
	const titles = [
		translations.SelectMaterial,
		translations.SelectShape,
		translations.SelectColor,
		translations.SelectGrosGrain,
		translations.SelectBow,
		translations.SelectVeil,
		translations.SelectSize,
	];

	// Step configuration: selectors, field names, and display names
	const stepConfig = [
		{ selector: ".material-option", fieldName: "material", displayName: translations.material },
		{ selector: ".shape-option", fieldName: "shape", displayName: translations.shape },
		{ selector: ".color-option", fieldName: "color", displayName: translations.color },
		{
			selector: ".ribbon-option",
			fieldName: "ribbon",
			displayName: translations.grosGrain,
		},
		{ selector: ".bow-option", fieldName: "bow", displayName: translations.bow },
		{ selector: ".veil-option", fieldName: "veil", displayName: translations.veil },
		{ selector: ".size-option", fieldName: "size", displayName: translations.size },
	];

	// Track user selections for each step
	let stepValues = Array(steps.length).fill("");

	// --- Option Filtering & Step Navigation Helpers ---

	// Check if a step has any visible options
	function hasVisibleOptions(selector) {
		return Array.from(document.querySelectorAll(selector)).some((opt) => opt.style.display !== "none");
	}

	// Hide options that are not compatible with the selected value
	function filterOptionsByAttribute(selector, attribute, selectedValue) {
		document.querySelectorAll(selector).forEach((option) => {
			const excludeValues = option.getAttribute(attribute);
			if (!selectedValue) {
				option.style.display = "";
				return;
			}
			const excludeList = excludeValues ? excludeValues.split(",").map((s) => s.trim().toLowerCase()) : [];
			const shouldHide = excludeList.includes(selectedValue.toLowerCase());
			option.style.display = shouldHide ? "none" : "";
			if (shouldHide) {
				const input = option.querySelector('input[type="radio"]');
				if (input) input.checked = false;
				option.classList.remove("selected");
			}
		});
	}

	// Find the next step with visible options
	function findNextValidStep(fromStep) {
		let step = fromStep + 1;
		while (step < steps.length - 1) {
			if (stepConfig[step] && hasVisibleOptions(stepConfig[step].selector)) {
				return step;
			}
			step++;
		}
		return steps.length - 1; // Default to summary if none found
	}

	// Find the previous step with visible options
	function findPrevValidStep(fromStep) {
		let step = fromStep - 1;
		while (step >= 0) {
			if (stepConfig[step] && hasVisibleOptions(stepConfig[step].selector)) {
				return step;
			}
			step--;
		}
		return 0;
	}

	// --- Sidebar & Summary Updates ---

	// Update the ribbon sidebar with selected color info
	function updateRibbonSidebar() {
		const ribbon = document.querySelector('input[name="ribbon"]:checked');
		const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
		const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');
		const ribbonSidebarEl = sidebarSteps[3]?.querySelector(".step-value");
		if (ribbonSidebarEl) {
			if (ribbon) {
				let html = translations.type + " : " + ribbon.value + "; <br>";
				html += translations.mainColor + " : " + (mainColor ? mainColor.value : "") + "; <br>";
				if (ribbon.value.trim().toLowerCase() !== "simple") {
					html += translations.secondaryColor + " : " + (secondColor ? secondColor.value : "") + "; <br>";
				}
				ribbonSidebarEl.innerHTML = html;
			} else {
				ribbonSidebarEl.innerHTML = "";
			}
		}
	}

	// Show all selected options in the final summary
	function updateSummary() {
		const fieldsToUpdate = [
			{ input: "material", summary: "summary-material" },
			{ input: "shape", summary: "summary-shape" },
			{ input: "color", summary: "summary-color" },
			{ input: "ribbon", summary: "summary-ribbon" },
			{ input: "bow", summary: "summary-bow" },
			{ input: "veil", summary: "summary-veil" },
			{ input: "size", summary: "summary-size" },
		];

		fieldsToUpdate.forEach((field) => {
			const selected = document.querySelector(`input[name="${field.input}"]:checked`);
			const summaryEl = document.getElementById(field.summary);
			if (field.input == "veil") {
				const priceEl = document.getElementById("summary-price");
				priceEl.textContent = selected ? selected.getAttribute("data-price") : "-";
			}
			if (summaryEl) {
				summaryEl.textContent = selected?.value || "-";
			}
		});

		// Handle ribbon color summary
		const ribbon = document.querySelector('input[name="ribbon"]:checked');
		const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
		const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');
		const ribbonColorEl = document.getElementById("summary-ribbon-color");
		if (ribbonColorEl) {
			ribbonColorEl.textContent = mainColor && mainColor.value ? mainColor.value : "-";
		}
		const secondaryColorEl = document.getElementById("summary-ribbon-secondary-color");
		const secondaryColorLi = secondaryColorEl ? secondaryColorEl.closest("li") : null;
		if (secondaryColorEl && secondaryColorLi) {
			if (ribbon && ribbon.value.trim().toUpperCase() === "DOUBLE" && secondColor && secondColor.value) {
				secondaryColorEl.textContent = secondColor.value;
				secondaryColorLi.style.display = "";
			} else {
				secondaryColorEl.textContent = "-";
				secondaryColorLi.style.display = "none";
			}
		}
	}

	// --- Button State & Highlighting ---

	// Enable/disable next button based on current step and selections
	function updateNextButtonState() {
		const nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
		const prevBtnMobile = document.getElementById("funnel-prev-btn-mobile");
		const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 60;

		// Scroll to funnel container on next button click
		[nextBtn, nextBtnMobile, prevBtnMobile, prevBtn].forEach((btn) => {
			btn.addEventListener("click", () => {
				const funnelContainer = document.querySelector(".funnel-container");
				if (funnelContainer) {
					const y = funnelContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight;
					window.scrollTo({ top: y, behavior: "smooth" });
				}
			});
		});

		if (currentStep >= stepConfig.length) {
			nextBtn.disabled = true;
			nextBtnMobile.disabled = true;
			return;
		}
		if (!hasVisibleOptions(stepConfig[currentStep].selector)) {
			nextBtn.disabled = true;
			nextBtnMobile.disabled = true;
			return;
		}
		// Special validation for ribbon step
		if (currentStep === 3) {
			const ribbon = document.querySelector('input[name="ribbon"]:checked');
			const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
			const secondWrapper = document.getElementById("ribbon-color-second-wrapper");
			const secondColorRequired = ribbon && ribbon.value.trim().toUpperCase() === "DOUBLE" && secondWrapper && secondWrapper.style.display !== "none";
			const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');
			const isDisabled = !ribbon || !mainColor || (secondColorRequired && !secondColor);
			nextBtn.disabled = isDisabled;
			nextBtnMobile.disabled = isDisabled;
			return;
		}
		// For other steps, just check if something is selected
		const hasSelection = document.querySelector(`input[name="${stepConfig[currentStep].fieldName}"]:checked`);
		const isDisabled = !hasSelection;
		nextBtn.disabled = isDisabled;
		nextBtnMobile.disabled = isDisabled;
	}

	// Highlight the currently selected options
	function highlightSelectedOptions() {
		stepConfig.forEach((config) => {
			document.querySelectorAll(config.selector).forEach((opt) => opt.classList.remove("selected"));
			const selected = document.querySelector(`input[name="${config.fieldName}"]:checked`);
			if (selected) {
				const option = selected.closest(config.selector);
				if (option) option.classList.add("selected");
			}
		});
		// Ribbon color options
		["#ribbon-color-main", "#ribbon-color-second"].forEach((parentSelector) => {
			const fieldName = parentSelector.includes("main") ? "ribbon_color_main" : "ribbon_color_second";
			document.querySelectorAll(`${parentSelector} .ribbon-color-option`).forEach((opt) => opt.classList.remove("selected"));
			const selected = document.querySelector(`input[name="${fieldName}"]:checked`);
			if (selected) {
				const option = selected.closest(".ribbon-color-option");
				if (option) option.classList.add("selected");
			}

			// Selected ribbon color options
			const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
			const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');

			const mainColorValue = mainColor ? mainColor.value : null;
			const secondColorValue = secondColor ? secondColor.value : null;

			// Disable same color selection for main and second ribbon colors
			[
				{ name: "ribbon_color_main", otherValue: secondColorValue },
				{ name: "ribbon_color_second", otherValue: mainColorValue },
			].forEach(({ name, otherValue }) => {
				document.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
					const option = input.closest(".ribbon-color-option");
					const shouldDisable = otherValue && input.value === otherValue;
					input.disabled = !!shouldDisable;
					if (option) option.style.opacity = shouldDisable ? "40%" : "";
					if (shouldDisable && input.checked) input.checked = false;
				});
			});
		});
	}

	// --- Step Resetting ---

	// Clear selections after changing an earlier step
	function resetSelectionsAfterStep(step) {
		const fieldsToReset = stepConfig.slice(step + 1).map((config) => config.fieldName);
		fieldsToReset.push("ribbon_color_main", "ribbon_color_second");
		fieldsToReset.forEach((fieldName) => {
			document.querySelectorAll(`input[name="${fieldName}"]`).forEach((input) => {
				input.checked = false;
			});
			const selector = fieldName.replace(/_/g, "-") + "-option";
			document.querySelectorAll(`.${selector}`).forEach((option) => {
				option.classList.remove("selected");
			});
		});
		// Clear sidebar display for reset steps
		stepValues.fill("", step + 1);
		sidebarSteps.forEach((s, i) => {
			if (i > step) {
				const valueEl = s.querySelector(".step-value");
				if (valueEl) valueEl.textContent = "";
			}
		});
	}

	// --- Step Display Logic ---

	// Show a specific step in the funnel
	function showStep(stepIndex) {
		// Skip empty steps
		if (stepIndex < steps.length - 1 && stepConfig[stepIndex] && !hasVisibleOptions(stepConfig[stepIndex].selector)) {
			showStep(findNextValidStep(stepIndex));
			return;
		}
		// Update visibility of each step
		steps.forEach((step, i) => {
			step.classList.toggle("active", i === stepIndex);
			step.style.display = i === stepIndex ? "" : "none";
			step.setAttribute("aria-hidden", i === stepIndex ? "false" : "true");
			step.querySelectorAll("input, button, select, textarea").forEach((el) => {
				el.disabled = i !== stepIndex;
				el.tabIndex = i === stepIndex ? 0 : -1;
			});
		});
		// Update sidebar display
		sidebarSteps.forEach((step, i) => {
			const hasOptions = stepConfig[i] && hasVisibleOptions(stepConfig[i].selector);
			step.classList.toggle("completed", i < stepIndex && hasOptions);
			step.classList.toggle("active", i === stepIndex && i < sidebarSteps.length);
			const valueEl = step.querySelector(".step-value");
			if (!valueEl) return;
			if (i === 3) {
				updateRibbonSidebar();
			} else {
				valueEl.textContent = stepValues[i] || "";
			}
		});
		// Update page title and button state
		if (stepIndex < titles.length) {
			titleEl.textContent = titles[stepIndex];
		} else {
			titleEl.textContent = "";
		}
		if (stepIndex === steps.length - 1) {
			nextBtn.style.display = "none";
			prevBtn.style.display = "block";
			// Put previous button in the contact button area
			document.querySelector(".contact__button").appendChild(prevBtn);
			updateSummary();
		} else {
			nextBtn.style.display = "";
			prevBtn.style.display = "";
			prevBtn.disabled = stepIndex === 0;
			const currentStepHasValue = stepValues[stepIndex] && stepValues[stepIndex].trim() !== "";
			nextBtn.disabled = !currentStepHasValue;
			const nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
			const prevBtnMobile = document.getElementById("funnel-prev-btn-mobile");
			if (nextBtnMobile) nextBtnMobile.disabled = !currentStepHasValue;
			if (prevBtnMobile) prevBtnMobile.disabled = stepIndex === 0;
			// Move previous button back to the steps navigation area
			document.querySelector(".steps_nav__button").insertBefore(prevBtn, document.querySelector(".steps_nav__button").firstChild);
		}
		currentStep = stepIndex;
	}

	// --- Misc Helpers ---

	// Update gros grain images based on selected material
	function updateRibbonImages() {
		const material = document.querySelector('input[name="material"]:checked')?.value?.trim().toLowerCase();
		document.querySelectorAll(".ribbon-option").forEach((option) => {
			const pailleImg = option.querySelector(".ribbon-img-straw");
			const feutreImg = option.querySelector(".ribbon-img-felt");
			if (!pailleImg || !feutreImg) return;
			if (material === "straw" || material === "paille") {
				pailleImg.style.display = "";
				feutreImg.style.display = "none";
			} else {
				pailleImg.style.display = "none";
				feutreImg.style.display = "";
			}
		});
	}

	// --- Event Handlers ---

	// Handle all form changes
	document.addEventListener("change", function (e) {
		const name = e.target.name;
		if (name === "material") {
			stepValues[0] = e.target.value;
			filterOptionsByAttribute(".shape-option", "data-no-show-material", e.target.value);
			filterOptionsByAttribute(".color-option", "data-no-show-material", e.target.value);
			resetSelectionsAfterStep(0);
			updateRibbonImages();
		}
		if (name === "shape") {
			stepValues[1] = e.target.value;
			filterOptionsByAttribute(".ribbon-option", "data-no-show-shape", e.target.value);
			filterOptionsByAttribute(".bow-option", "data-no-show-shape", e.target.value);
			filterOptionsByAttribute(".veil-option", "data-no-show-shape", e.target.value);
			resetSelectionsAfterStep(1);
		}
		if (name === "color") {
			stepValues[2] = e.target.value;
		}
		if (name === "ribbon") {
			stepValues[3] = e.target.value;
			const showSecondary = e.target.value.trim().toUpperCase() === "DOUBLE";
			const secondaryWrapper = document.getElementById("ribbon-color-second-wrapper");
			if (secondaryWrapper) {
				secondaryWrapper.style.display = showSecondary ? "" : "none";
				if (!showSecondary) {
					document.querySelectorAll('input[name="ribbon_color_second"]').forEach((i) => (i.checked = false));
				}
			}
			updateRibbonSidebar();
		}
		if (name === "ribbon_color_main" || name === "ribbon_color_second") {
			updateRibbonSidebar();
		}
		if (name === "bow") {
			stepValues[4] = e.target.value;
		}
		if (name === "veil") {
			stepValues[5] = e.target.value;
		}
		if (name === "size") {
			stepValues[6] = e.target.value;
			const label = e.target.closest(".size-option").querySelector(".size-label");
			document.getElementById("selected-size-label").textContent = label ? label.textContent[0] : "-";
		}
		stepConfig.forEach((config, index) => {
			if (name === config.fieldName && index < sidebarSteps.length) {
				const valueEl = sidebarSteps[index]?.querySelector(".step-value");
				if (valueEl) valueEl.textContent = e.target.value;
			}
		});
		highlightSelectedOptions();
		updateNextButtonState();
	});

	// Next button - validate and move forward
	nextBtn.addEventListener("click", function () {
		if (currentStep < stepConfig.length) {
			if (currentStep === 3) {
				const ribbon = document.querySelector('input[name="ribbon"]:checked');
				const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
				const secondWrapper = document.getElementById("ribbon-color-second-wrapper");
				const secondColorRequired =
					ribbon && ribbon.value.trim().toUpperCase() === "DOUBLE" && secondWrapper && secondWrapper.style.display !== "none";
				const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');
				if (!ribbon || !mainColor || (secondColorRequired && !secondColor)) return;
			} else if (hasVisibleOptions(stepConfig[currentStep].selector)) {
				const hasSelection = document.querySelector(`input[name="${stepConfig[currentStep].fieldName}"]:checked`);
				if (!hasSelection) return;
			}
		}
		const nextStep = findNextValidStep(currentStep);
		if (nextStep < steps.length) showStep(nextStep);
	});

	// Previous button - simple navigation
	prevBtn.addEventListener("click", function () {
		const prevStep = findPrevValidStep(currentStep);
		if (prevStep >= 0) showStep(prevStep);
	});

	// --- Initial Setup ---

	// Filter options based on any pre-selected values
	filterOptionsByAttribute(".shape-option", "data-no-show-material", document.querySelector('input[name="material"]:checked')?.value || "");
	filterOptionsByAttribute(".color-option", "data-no-show-material", document.querySelector('input[name="material"]:checked')?.value || "");
	filterOptionsByAttribute(".ribbon-option", "data-no-show-shape", document.querySelector('input[name="shape"]:checked')?.value || "");
	filterOptionsByAttribute(".bow-option", "data-no-show-shape", document.querySelector('input[name="shape"]:checked')?.value || "");
	filterOptionsByAttribute(".veil-option", "data-no-show-shape", document.querySelector('input[name="shape"]:checked')?.value || "");
	updateRibbonImages();
	showStep(currentStep);
})();
